import { Link } from "react-router";
import PropTypes from "prop-types";
import React from "react";

const LocationResult = ({ item, region }) => {
  const link = (item) => {
    return region + `/sales?${item.key}=` + item.locationName;
  };

  return (
    <li className="location-result">
      <Link to={link(item)} title={item.locationName}>
        <strong dangerouslySetInnerHTML={{ __html: item.locationName }} />
      </Link>
    </li>
  );
};

LocationResult.propTypes = {
  item: PropTypes.object.isRequired,
  region: PropTypes.string.isRequired,
};

export default LocationResult;



// WEBPACK FOOTER //
// ./src/components/homepage/hero-slider/search-widget/quick-suggest/location-result.js